import { render, staticRenderFns } from "./AppBrandLogo.vue?vue&type=template&id=46c4da45&scoped=true"
import script from "./AppBrandLogo.vue?vue&type=script&lang=js"
export * from "./AppBrandLogo.vue?vue&type=script&lang=js"
import style0 from "./AppBrandLogo.vue?vue&type=style&index=0&id=46c4da45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c4da45",
  null
  
)

export default component.exports